import { api } from "./api";

/** One entry under the bell (GET /notifications). */
export interface AppNotification {
  id: string;
  event: string;
  title: string;
  body: string;
  /** App path opened on click, e.g. "/company/bookings/R-26-1046". */
  link: string | null;
  read: boolean;
  createdAt: string;
}

/** GET /notifications — newest first, plus the unread count. */
export async function getNotifications(before?: string): Promise<{ items: AppNotification[]; unread: number }> {
  const { data } = await api.get<{ items: AppNotification[]; unread: number }>("/notifications", {
    params: { limit: 20, ...(before && { before }) },
  });
  return data;
}

/** GET /notifications/unread-count — polled by the bell. */
export async function getUnreadCount(): Promise<number> {
  const { data } = await api.get<{ unread: number }>("/notifications/unread-count");
  return data.unread;
}

/** POST /notifications/:id/read — returns the new unread count. */
export async function markNotificationRead(id: string): Promise<number> {
  const { data } = await api.post<{ unread: number }>(`/notifications/${encodeURIComponent(id)}/read`);
  return data.unread;
}

/** POST /notifications/read-all */
export async function markAllNotificationsRead(): Promise<void> {
  await api.post("/notifications/read-all");
}

/** POST /notifications/push-tokens — this browser accepts push notifications. */
export async function registerPushToken(token: string): Promise<void> {
  await api.post("/notifications/push-tokens", { token });
}

/** DELETE /notifications/push-tokens — on logout. */
export async function removePushToken(token: string): Promise<void> {
  await api.delete("/notifications/push-tokens", { data: { token } });
}
